import type { FaireProductEntity } from "../../entity_types/product";

export const p_zbyue2z3pp: FaireProductEntity = {
  token: "p_zbyue2z3pp",
  type: "product",
  name: "Vases thank you greeting card",
  brandToken: "b_4cu4uycf",
  brandName: "Red Cap Cards",
  imageUrl:
    "https://cdn.faire.com/fastly/b95144d107b652abd3f266cff999c16611f2ed216e8e436e404f8d5fe85043bf.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/3bf0545df3acae6f6650c138e124408bea22328e8c94eb28ba01b304c3259250.jpeg",
  ],
  priceDollars: 2.75,
  description:
    "Blank inside. 100lb heavyweight card stock. Offset printed. 4.25 x 5.5 inches. Illustrated by Emily Isabella. Printed by Red Cap Cards in Los Angeles, California, USA, on recycled paper.\nAvailable as both single cards and pre-packaged boxed cards.\n• Each single card comes with an envelope and a cellophane sleeve.\n• Boxed sets are 8 cards with envelopes and are to be sold as packaged, not to be re-sold as individual cards.",
  tags: [],
  msrpDollars: 5.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:55:28.529Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
